import { registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./app.html";
import LightningElementSLDS from 'util/lightningElementSLDS';
import { eventTypes, fireEvent, registerListener, unregisterAllListeners } from 'util/pubsub';
// import { getLoggedInUser } from 'data/authService';
// import { eventTypes, fireEvent } from 'util/pubsub';
// import {createCloudWatchObject,sendLogsToAws,getNextSequenceToken,saveLogs} from 'util/awsCloudwatch';//ORV240807 comment aws-sdk use
import { setApp, closeSidebar, clearSidebar } from './appUtil';
import { isMobile } from 'util/commonFunctions';
class App extends LightningElementSLDS {
  constructor(...args) {
    super(...args);
    this.loggedUser = undefined;
    this.isLoggedIn = false;
    this.displayMobileToolbar = false;
    this.displayToolbar = void 0;
    //ORV240827 display toolbar for mobile
    this.tParam = void 0;
    this.hideSearchBar = __g_hideSearchBar;
    //ORV240717 pass hideSearchBar to child component page buttons
    // This is needed by the pubsub code to assure that events are only sent between components on the same page. We
    // need to come up with some attribute(s) that we can use to mark the components as belonging to a certain page/application.
    this.pageRef = {
      attributes: {
        "developer": "zPaper",
        "application": "Document Viewer"
      }
    };
    this.parentLoadsPdf = true;
  }
  connectedCallback() {
    this.displayMobileToolbar = isMobile();
    //ORV249827 get t param better way user global variable
    let urlParams = new URLSearchParams(window.location.search);
    this.tParam = urlParams.get('t');
    if (isMobile() && this.tParam?.toLowerCase() != 'off') {
      this.displayToolbar = true;
      registerListener("initialize-zplib", this.callInitializeZpLib, this);
    }
    // createCloudWatchObject(); //ORV240807 comment aws-sdk use
    setApp(this);
    //setInterval(sendLogsToAws, 600000);
    // ORV240807 comment aws-sdk use
    // window.createCloudWatchObject = createCloudWatchObject;
    // window.getNextSequenceToken = getNextSequenceToken;
    // window.sendLogsToAws = sendLogsToAws;
    // window.saveLogs = saveLogs;

    let self = this;
    console.log('@@@@ Pulling logged-in user info @@@@');
    this.addEventListener("zippi-login-successful", function (evt) {
      // debugger;
      console.log("WE ARE LOGGED INTO ZIPPI: ", evt);
      self.isLoggedIn = true;
    });
    self.isLoggedIn = true;
    self.loggedUser = "fred";
    __g_windowInfo.windowWidth = window.innerWidth;
    __g_windowInfo.windowHeight = window.innerHeight;
    let previousResizeHandler = window.onresize;
    window.onresize = function (evt) {
      __g_windowInfo.windowWidth = window.innerWidth;
      __g_windowInfo.windowHeight = window.innerHeight;
      if (previousResizeHandler) {
        previousResizeHandler(evt);
      }
    };
  }
  renderedCallback() {
    console.log("renderedCallback - app.js");
    window.__g_appCmpForDebugging = this; //added temporariy for debugging
    window.__g_appTemplateForDebugging = this.template; //added temporariy for debugging
    console.log(this.template.querySelector(".bottombarPanel"));
  }
  handleLeftColumnCancel() {
    clearSidebar();
    closeSidebar();
  }
  callInitializeZpLib(evt) {
    //console.log("callInitializeZpLib : " + JSON.stringify(evt));
    console.log("buttons:", evt.buttons);
    let pdfViewerToolbar = this.template.querySelector("zpaper-pdf-viewer-toolbar");
    let self = this;
    let pageButtonsLoadTimer = setInterval(() => {
      //initialize page buttons in mobile
      let pageButtons = this.template.querySelector("zpaper-page-buttons");
      if (pageButtons) {
        clearInterval(pageButtonsLoadTimer);
        let options = {};
        options.currentPageNumber = 1;
        options.maxPages = __g_pdfDoc___.numPages;
        options.pdfDoc = __g_pdfDoc___;
        pageButtons.setPdfPageDetails(options);
      }
    }, 250);
    let toolbarLoadTimer = setInterval(() => {
      console.log("Attempting to set up the toolbar: ", pdfViewerToolbar);
      pdfViewerToolbar = self.template.querySelector("zpaper-pdf-viewer-toolbar");
      if (pdfViewerToolbar) {
        clearInterval(toolbarLoadTimer);
        let toolbarParams = evt.loadBasicToolbar ? {
          pdfPage: evt.pdfPage,
          pdfPageOverlay: evt.pdfPageOverlay,
          buttons: evt.buttons,
          pdfInfo: evt.pdfInfo,
          pdfViewerMainPane: evt.pdfViewerMainPane,
          loadBasicToolbar: evt.loadBasicToolbar,
          loadingDefaultPdf: evt.loadingDefaultPdf,
          source: evt.source,
          sourceUrl: evt.sourceUrl,
          htmlFile: evt.htmlFile //AHS260512+Claude - pass htmlFile so mobile toolbar loads toolbars-html.json
        } : {
          pdfPage: evt.pdfPage,
          pdfPageOverlay: evt.pdfPageOverlay,
          buttons: evt.buttons,
          pdfInfo: evt.pdfInfo,
          pdfViewerMainPane: evt.pdfViewerMainPane,
          loadingDefaultPdf: evt.loadingDefaultPdf,
          source: evt.source,
          sourceUrl: evt.sourceUrl,
          htmlFile: evt.htmlFile //AHS260512+Claude - pass htmlFile so mobile toolbar loads toolbars-html.json
        };
        if (isMobile()) {
          pdfViewerToolbar.initializeZpLibMobile(toolbarParams);
        } else {
          pdfViewerToolbar.initializeZpLib(toolbarParams);
        }
        console.log(evt.pdfViewerMainPane);
        console.log("callInitializeZpLib end");
        console.log($(evt.pdfViewerMainPaneTemplate));
        console.log(evt.pdfViewerMainPaneTemplate && evt.pdfViewerMainPaneTemplate.querySelector(".pdfPage"));
      }
    }, 250);
  }
}
_registerDecorators(App, {
  track: {
    loggedUser: 1,
    isLoggedIn: 1
  },
  fields: ["displayMobileToolbar", "displayToolbar", "tParam", "hideSearchBar", "pageRef", "parentLoadsPdf"]
});
export default _registerComponent(App, {
  tmpl: _tmpl
});